import React from "react";
import Routes from "./Routes";
import { ToastProvider } from './hooks/useToast';
import { AuthProvider } from './contexts/AuthContext';
import ToastManager from './components/ToastManager';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes />
        <ToastManager />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
